/**
 * Глобальні alert-модалки замість нативного window.alert().
 * Використання: `showAlert(повідомлення)` або `showAlert(msg, 'Заголовок')`.
 */
import { writable } from 'svelte/store';

export interface AlertState {
  message: string;
  title: string;
}

export const alertStore = writable<AlertState | null>(null);

export function showAlert(message: string, title = 'Помилка'): void {
  alertStore.set({ message, title });
}

export function dismissAlert(): void {
  alertStore.set(null);
}
